import React, { useEffect, useState } from "react";
import {
  Logo,
  SmallLogo,
  Closes,
  HeaderSearch,
  Flag,
  FlagUS,
  FlagFR,
  FlagES,
  FlagDE,
  Notification,
  Avatar2,
  Avatar3,
  Avatar6,
  Avatar17,
  Avatar13,
  Avatar,
  Logout,
  Noimage,
} from "../../../common/imagePath";
import { Link } from "react-router-dom";
import { checkUserPermission } from "../../../common/UserPermission";
import Select from "react-select";
import config from "../../../config/config";
import axios from "axios";
import { toastSuccess } from "../../../common/Toast";
import { SUCCESS_MESSAGE } from "../../../common/Constant";
import Loader from "../../../components/Loader/Loader";

const Header = () => {
  const [searchBar, SetSearchBar] = useState(false);
  const [toggle, SetToggle] = useState(false);
  const Id = localStorage.getItem("ID");
  const Name = localStorage.getItem("Name");
  const EmailId = localStorage.getItem("EmailId");
  const Selectimage = localStorage.getItem("Selectimage");
  const [locationDropdown, setLocationDropdown] = useState([]);
  const token = localStorage.getItem("Token");
  const [selectedlocation, setSelectedLocation] = useState(0);
  const [loading, setLoading] = useState(false);
  let iscustomer = localStorage.getItem("IsCustomer");

  const handlesidebar = () => {
    document.body.classList.toggle("mini-sidebar");
    SetToggle((current) => !current);
  };

  const expandMenu = () => {
    document.body.classList.remove("expand-menu");
  };

  const expandMenuOpen = () => {
    document.body.classList.add("expand-menu");
  };

  const sidebarOverlay = () => {
    document.querySelector(".main-wrapper").classList.toggle("slide-nav");
    document.querySelector(".sidebar-overlay").classList.toggle("opened");
    document.querySelector("html").classList.toggle("menu-opened");
  };

  // let navigate = useNavigate();

  const signOut = () => {
    localStorage.clear();

    sessionStorage.clear();

    // navigate("/login");
    window.location.href = "/login";
  };

  let pathname = window.location.pathname;
  const location = localStorage.getItem("Location");
  const locationvariable = JSON.parse(localStorage.getItem("LocationVariable"));
  const locationarray = locationvariable?.LocationName.split(",");
  // console.log(locationname,"locationname")

  useEffect(() => {
    setSelectedLocation(location);
  }, [location]);

  useEffect(() => {
    axios
      .get(`${config.locationBaseUrl}/locations/locationdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setLocationDropdown(res.data.ResponseData);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  let locationDropdownOption = [];
  const Dropdown = locationDropdown.map((u, i) => {
    locationDropdownOption[i] = { label: u.Name, value: u.Id };
  });

  const selectStyles = {
    // dropdown input css
    control: (provided, state) => ({
      ...provided,
      width: "111%",
      height: "40px",
      marginTop: "10px",
      // marginLeft: "20px",
      position: "relative",
      border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
      boxShadow: state.isFocused ? "none" : "inset 0 1px 0 rgba(0, 0, 0, 0.1)", // remove box shadow when hovering
      "&:hover": {
        border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
      },
    }),
    // dropdown menu css
    menu: () => ({
      boxShadow: "inset 0 1px 0 rgba(255, 149, 0, 0.1)",
      position: "absolute",
      "z-index": "999",
      background: "#f8f8f8",
      width: "111%",
    }),
    // dropdown option css
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? "rgba(255, 149, 0, 0.1)" : "#fff", // change hover color to light orange
      "&:hover": {
        backgroundColor: "rgba(255, 149, 0, 0.1)", // change hover color to light orange
      },
    }),
  };

  // console.log(locationname,"locationname")

  const handleWarehouse = (e) => {
    console.log(e, "event");
    localStorage.setItem("Location", e.value);
    setSelectedLocation(e.value);

    setLoading(true);
    axios
      .post(
        `${config.authenticationBaseUrl}/users/locationupsert`,
        {
          loginuserid: Id,
          locationid: e.value,
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        // console.log("res ==> ", res.data.ResponseData);

        //  toastSuccess(SUCCESS_MESSAGE);
        console.log(res.data);
        window.location.reload();
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });

    //  location=localStorage.getItem("Location")
  };

  console.log(selectedlocation, "selectedlocation");
  return (
    <>
      <Loader loading={loading} />
      <div className="header">
        {/* Logo */}
        <div
          className={`header-left ${toggle ? "" : "active"}`}
          onMouseLeave={expandMenu}
          onMouseOver={expandMenuOpen}
        >
          {iscustomer == 0 || iscustomer == null || iscustomer == undefined ? (
            <>
              <Link to="/dashboard" className="logo">
                <img src={Logo} alt="" />
              </Link>
              <Link to="/dashboard" className="logo-small">
                <img src={SmallLogo} alt="" />
              </Link>
            </>
          ) : (
            <>
              <Link to="#" className="logo">
                <img src={Logo} alt="" />
              </Link>
              <Link to="#" className="logo-small">
                <img src={SmallLogo} alt="" />
              </Link>
            </>
          )}
          <Link
            id="toggle_btn"
            to="#"
            style={{
              display: pathname.includes("tasks")
                ? "none"
                : pathname.includes("compose")
                ? "none"
                : "",
            }}
            onClick={handlesidebar}
          ></Link>{" "}
        </div>
        {/* /Logo */}
        <Link
          id="mobile_btn"
          className="mobile_btn"
          to="#"
          onClick={sidebarOverlay}
        >
          <span className="bar-icon">
            <span />
            <span />
            <span />
          </span>
        </Link>
        {/* Header Menu */}

        {/* <div className="w-50 border border-primary"> */}

        <ul className={searchBar ? "nav user-menu  " : "nav user-menu  "}>
          {/*          
          {locationarray?.length > 1 ? 
          <li className="nav mr-3">


           
            <Select
                
                value={locationDropdownOption?.find((option)=>option?.value==selectedlocation)}
               
                options={locationDropdownOption}
                placeholder="Warehouse"
                backspaceRemovesValue={false}
                controlShouldRenderValue={true}
                hideSelectedOptions={true}
                isClearable={true}
                styles={selectStyles}
                
                onChange={(event) => handleWarehouse(event)}
              />
          </li> : ""} */}

          {/* {searchBar ?

            <li className="nav-item ml-5">



              <div className="top-nav-search  ">

               

                <form action="#">



                  <div className={`searchinputs ${searchBar ? "show " : ""}`}>
                    <input type="text" placeholder="Search Here ..." />
                    <div
                      className="search-addon"
                      onClick={() => SetSearchBar(false)}
                    >
                      <span>
                        <img src={Closes} alt="img" />
                      </span>
                    </div>
                  </div>


                </form>
              </div>
            </li> : ""} */}

          {/* <div>

            <li className="nav-item mt-2 ml-3">
              <Link
                to="#"
                className="btn"
                id="searchdiv"
                onClick={() => SetSearchBar(true)}
              >
                <img src={HeaderSearch} alt="img" />
              </Link>
            </li>
          </div> */}

          {/* /Search */}
          {/* Flag */}

          {/* <li className="nav-item dropdown has-arrow flag-nav">
            <Link
              to="#"
              className="nav-link dropdown-toggle"
              data-bs-toggle="dropdown"
              role="button"
            >
              <img src={Flag} alt="" height={20} />
            </Link>
            <div className="dropdown-menu dropdown-menu-right">
              <Link to="#" className="dropdown-item">
                <img src={FlagUS} alt="" height={16} /> English
              </Link>
              <Link to="#" className="dropdown-item">
                <img src={FlagFR} alt="" height={16} /> French
              </Link>
              <Link to="#" className="dropdown-item">
                <img src={FlagES} alt="" height={16} /> Spanish
              </Link>
              <Link to="#" className="dropdown-item">
                <img src={FlagDE} alt="" height={16} /> German
              </Link>
            </div>
          </li>
           */}

          {/* /Flag */}
          {/* Notifications */}

          {/* <li className="nav-item dropdown">
            <Link
              to="#"
              className="dropdown-toggle nav-link"
              data-bs-toggle="dropdown"
            >
              <img src={Notification} alt="img" className="noti-image" />
              <span className="badge rounded-pill">4</span>
            </Link>
            <div className="dropdown-menu notifications">
              <div className="topnav-dropdown-header">
                <span className="notification-title">Notifications</span>
                <Link to="#" className="clear-noti">
                  {" "}
                  Clear All{" "}
                </Link>
              </div>
              <div className="noti-content">
                <ul className="notification-list">
                  <li className="notification-message">
                    <Link to="/activities">
                      <div className="media d-flex">
                        <span className="avatar flex-shrink-0">
                          <img alt="" src={Avatar2} />
                        </span>
                        <div className="media-body flex-grow-1">
                          <p className="noti-details">
                            <span className="noti-title">John Doe</span> added
                            new task{" "}
                            <span className="noti-title">
                              Patient appointment booking
                            </span>
                          </p>
                          <p className="noti-time">
                            <span className="notification-time">
                              4 mins ago
                            </span>
                          </p>
                        </div>
                      </div>
                    </Link>
                  </li>
                  <li className="notification-message">
                    <Link to="/activities">
                      <div className="media d-flex">
                        <span className="avatar flex-shrink-0">
                          <img alt="" src={Avatar3} />
                        </span>
                        <div className="media-body flex-grow-1">
                          <p className="noti-details">
                            <span className="noti-title">Tarah Shropshire</span>{" "}
                            changed the task name{" "}
                            <span className="noti-title">
                              Appointment booking with payment gateway
                            </span>
                          </p>
                          <p className="noti-time">
                            <span className="notification-time">
                              6 mins ago
                            </span>
                          </p>
                        </div>
                      </div>
                    </Link>
                  </li>
                  <li className="notification-message">
                    <Link to="/activities">
                      <div className="media d-flex">
                        <span className="avatar flex-shrink-0">
                          <img alt="" src={Avatar6} />
                        </span>
                        <div className="media-body flex-grow-1">
                          <p className="noti-details">
                            <span className="noti-title">Misty Tison</span>{" "}
                            added{" "}
                            <span className="noti-title">Domenic Houston</span>{" "}
                            and <span className="noti-title">Claire Mapes</span>{" "}
                            to project{" "}
                            <span className="noti-title">
                              Doctor available module
                            </span>
                          </p>
                          <p className="noti-time">
                            <span className="notification-time">
                              8 mins ago
                            </span>
                          </p>
                        </div>
                      </div>
                    </Link>
                  </li>
                  <li className="notification-message">
                    <Link to="/activities">
                      <div className="media d-flex">
                        <span className="avatar flex-shrink-0">
                          <img alt="" src={Avatar17} />
                        </span>
                        <div className="media-body flex-grow-1">
                          <p className="noti-details">
                            <span className="noti-title">Rolland Webber</span>{" "}
                            completed task{" "}
                            <span className="noti-title">
                              Patient and Doctor video conferencing
                            </span>
                          </p>
                          <p className="noti-time">
                            <span className="notification-time">
                              12 mins ago
                            </span>
                          </p>
                        </div>
                      </div>
                    </Link>
                  </li>
                  <li className="notification-message">
                    <Link to="/activities">
                      <div className="media d-flex">
                        <span className="avatar flex-shrink-0">
                          <img alt="" src={Avatar13} />
                        </span>
                        <div className="media-body flex-grow-1">
                          <p className="noti-details">
                            <span className="noti-title">Bernardo Galaviz</span>{" "}
                            added new task{" "}
                            <span className="noti-title">
                              Private chat module
                            </span>
                          </p>
                          <p className="noti-time">
                            <span className="notification-time">
                              2 days ago
                            </span>
                          </p>
                        </div>
                      </div>
                    </Link>
                  </li>
                </ul>
              </div>
              <div className="topnav-dropdown-footer">
                <Link to="/activities">View all Notifications</Link>
              </div>
            </div>
          </li> */}

          {/* /Notifications */}
          <li className="nav-item dropdown has-arrow main-drop">
            <Link
              to="#"
              className="dropdown-toggle nav-link userset"
              data-bs-toggle="dropdown"
            >
              <span className="user-img">
                <img
                  src={Selectimage}
                  onError={(e) => {
                    e.target.onError = null;
                    e.target.src = Noimage;
                  }}
                  alt=""
                />
              </span>
            </Link>
            <div className="dropdown-menu menu-drop-user">
              <div className="profilename">
                <div className="profileset">
                  <span className="user-img">
                    <img
                      src={Selectimage}
                      onError={(e) => {
                        e.target.onError = null;
                        e.target.src = Noimage;
                      }}
                      alt=""
                    />
                    {/* <span className="status online" /> */}
                  </span>
                  <div className="profilesets">
                    <h6>{Name}</h6>
                    <p className="email">{EmailId}</p>
                  </div>
                </div>
                <hr className="m-0" />
                {checkUserPermission("/edit-profile") && (
                  <Link className="dropdown-item" to={`/edit-profile`}>
                    <i className="me-2" data-feather="user" /> My Profile
                  </Link>
                )}
                {checkUserPermission("settings") && (
                  <Link className="dropdown-item" to="/storeconfig">
                    <i className="me-2" data-feather="settings" />
                    Settings
                  </Link>
                )}
                <hr className="m-0" />
                <Link className="dropdown-item logout pb-0" onClick={signOut}>
                  <img src={Logout} className="me-2" alt="img" />
                  Logout
                </Link>
              </div>
            </div>
          </li>
        </ul>
        {/* </div> */}
        {/* /Header Menu */}
        {/* Mobile Menu */}
        <div className="dropdown mobile-user-menu">
          <Link
            to="#"
            className="nav-link dropdown-toggle"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i className="fa fa-ellipsis-v" />
          </Link>
          <div className="dropdown-menu dropdown-menu-right">
            {iscustomer == 0 ||
            iscustomer == null ||
            iscustomer == undefined ? (
              <>
                <Link className="dropdown-item" to={`/edit-profile/${Id}`}>
                  My Profile
                </Link>
                <Link className="dropdown-item" to="/storeconfig">
                  Settings
                </Link>
                <Link className="dropdown-item" onClick={signOut}>
                  Logout
                </Link>
              </>
            ) : (
              <Link className="dropdown-item" onClick={signOut}>
                Logout
              </Link>
            )}
          </div>
        </div>
        {/* /Mobile Menu */}
      </div>
    </>
  );
};

export default Header;
